import { useMemo } from 'react';
import * as React from 'react';

import { BetType } from '@/lib/apollo/types/gen/graphql';
import { FirstThreeRacerList } from '@/modelTypes';

import { MultiSeparator, SingleSeparator, Text } from './style';

interface SetNumberProps {
  setNums: number[];
  betType: BetType;
  firstThreeRacerList?: FirstThreeRacerList; // マルチ表記の場合に必須
}

const SeparatorIcon: React.FC<{
  isSingle: boolean;
}> = React.memo(({ isSingle }) =>
  isSingle ? <SingleSeparator /> : <MultiSeparator />,
);

const SetNumber: React.FC<SetNumberProps> = ({
  setNums,
  betType,
  firstThreeRacerList,
}) => {
  const isSingle = [
    BetType.Trifecta,
    BetType.Perfecta,
    BetType.BracketPerfecta,
  ].includes(betType);

  const numLength = [BetType.Trifecta, BetType.Trio].includes(betType) ? 3 : 2;

  const setNumOfArray = useMemo(() => {
    const tempArray: number[][] = Array.from([...Array(numLength)], () => []);

    if (firstThreeRacerList) {
      firstThreeRacerList.forEach((racerNums, i) => {
        if (i <= numLength - 1) {
          tempArray[i] = racerNums.map(rn => {
            if (
              [BetType.BracketPerfecta, BetType.BracketQuinella].includes(
                betType,
              )
            ) {
              return rn.bracketNum;
            }
            return rn.bicycleNum;
          });
        }
      });
    } else {
      setNums.forEach(setNum => {
        setNum
          .toString()
          .split('')
          .forEach((v, i) => {
            tempArray[i].push(Number(v));
          });
      });
    }

    const setNumArray: number[] = [];
    tempArray.forEach(arr => {
      setNumArray.push(Number(Array.from(new Set(arr)).sort().join('')));
    });

    return setNumArray;
  }, [setNums, firstThreeRacerList]);

  return (
    <Text data-setnum={setNumOfArray.join(isSingle ? '-' : '=')}>
      {setNumOfArray.map((num, i) => (
        <React.Fragment key={`${betType}-${setNumOfArray.join('')}-${i}`}>
          {num}
          {i < setNumOfArray.length - 1 && (
            <SeparatorIcon isSingle={isSingle} />
          )}
        </React.Fragment>
      ))}
    </Text>
  );
};

export default SetNumber;
